import axios from "axios";
import qs from "qs";
import { addSignature } from "@/utils/signature";
import sma from "@/utils/sma";
import store from "@/store";
import router from "@/router";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 添加域名
  addSignature: false,
  // 添加token
  addToken: true,
  // 下载文件
  download: false,
  // 请求延迟时长，单位毫秒，默认0
  delayRequestTime: 0,
  // 响应延时时长，单位毫秒，默认0
  delayResponseTime: 0,
  withCredentials: true,
  timeout: 5000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  // 在向服务器发送前，转换请求数据
  transformRequest: [
    function (data, headers) {
      if (
        data &&
        headers["Content-Type"] === "application/x-www-form-urlencoded"
      ) {
        for (const [key, value] of Object.entries(data)) {
          if (Object.prototype.toString.call(value) === "[object Object]") {
            data[key] = JSON.stringify(value);
          }
        }
        data = qs.stringify(data);
      }
      return data;
    },
  ],
});

instance.interceptors.request.use(
  (config) => {
    if (config.addSignature) {
      // 为API增加签名
      config = addSignature(config);
    }
    if (config.addToken) {
      // 为API增加token
      config.headers.Token = store.state.token;
    }
    if (config.delayRequestTime > 0) {
      return delay(config, config.delayRequestTime);
    }
    return config;
  },
  (error) => {
    return Promise.request(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status && response.status !== 200) {
      return Promise.reject(res || "error");
    } else {
      if (response.config.download) {
        return Promise.resolve(response);
      }
      if (res.statusCode === 200) {
        res.code = 0;
      }

      if (res.code === 0) {
        if (response.config.delayResponseTime > 0) {
          return delay(res, response.config.delayResponseTime);
        } else {
          return Promise.resolve(res);
        }
      } else {
        if (res.code === 100000099) {
          if (sma?.isApp?.scienceChina) {
            sma.login();
          } else {
            if (router.currentRoute.name === "Login") {
              return;
            }
            router.replace(
              "/login?redirect=" +
                encodeURIComponent(router.currentRoute.fullPath)
            );
          }
        }
        if (res.code === 100000004) {
          res.errorMsg =
            Array.isArray(res.error) && res.error.length > 0
              ? res.error[0].value
              : res.msg;
        } else {
          res.errorMsg = res.msg;
        }
        return Promise.reject(res);
      }
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 延迟
function delay(obj, ms = 0) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(obj), ms);
  });
}

export default instance;
